var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37525 1.51648C9.28879 1.36001 9.16199 1.22958 9.00805 1.13875C8.85412 1.04791 8.67865 1 8.49992 1C8.32112 1 8.14565 1.04791 7.99172 1.13875C7.83779 1.22958 7.71099 1.36001 7.62459 1.51648L1.12456 13.5165C1.04051 13.6687 0.997611 13.8403 1.0001 14.0141C1.00259 14.188 1.05039 14.3583 1.13877 14.508C1.22716 14.6578 1.35307 14.7819 1.50409 14.8682C1.6551 14.9544 1.82599 14.9998 1.9999 14.9998H14.9999C15.1738 14.9998 15.3447 14.9544 15.4957 14.8682C15.6467 14.7819 15.7727 14.6578 15.8611 14.508C15.9494 14.3583 15.9972 14.188 15.9997 14.0141C16.0022 13.8403 15.9593 13.6687 15.8753 13.5165L9.37525 1.51648Z",
    stroke: "#D03450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10V5.5",
    stroke: "#D03450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5C8.36193 12.5 8.25 12.3881 8.25 12.25C8.25 12.1119 8.36193 12 8.5 12",
    stroke: "#D03450"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5C8.63807 12.5 8.75 12.3881 8.75 12.25C8.75 12.1119 8.63807 12 8.5 12",
    stroke: "#D03450"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconRed);
export default __webpack_public_path__ + "static/media/warning-icon-red.4a3e6c8cd92c3cd19e855a864d0489bd.svg";
export { ForwardRef as ReactComponent };